import {BrowserRouter,Routes,Route} from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import Category from "./components/Category/Category";
import SingleProduct from "./components/SingleProduct/SingleProduct";
import Newsletter from "./components/Footer/Newsletter/Newsletter";
import AppContext from "./utils/context";
import ImageCarousel from "./components/ImageCarousel/ImageCarousel";
import ServiceTab from "./components/Home/ServiceTab/ServiceTab";
import ServiceTabSlider from "./components/ServiceTabSlider/ServiceTabSlider";
import Client from "./components/Client/Client";
import Kalash from "./components/Kalash/Kalash";
import Imagecaro from "./components/Imagecaro/Imagecaro";
import Instagramfeed from "./components/Instagramfeed/Instagramfeed";
function App() {
    return (
        <BrowserRouter>
            <AppContext>
                <Header/>
                <Routes>      
                    <Route path="/" element={<Home/>}/>
                    <Route path="/category/:id" element={<Category/>}/>
                    <Route path="/product/:id" element={<SingleProduct/>}/>
                </Routes> 
                 {/* <ServiceTabSlider/> */}
                <Kalash/>
                <ImageCarousel/>
                <Client/>
                {/* <Imagecaro/> */}
                {/* <Instagramfeed/> */}
                {/* <Newsletter/>    */}
                <Footer/>  
            </AppContext> 
        </BrowserRouter>
    );
};
export default App;
